import { createSlice } from '@reduxjs/toolkit'

export const cashoutPopupSlice = createSlice({
    name: 'cashoutPopUp',
    initialState: {
        isOpen: false,
        market: null,
    },
    reducers: {
        setIsCashOutPopup: (state, action) => ({ isOpen: action.payload.isOpen, market: action.payload.market })
    },
})

export const {
    setIsCashOutPopup
} = cashoutPopupSlice.actions

export default cashoutPopupSlice.reducer
